import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SugerenciasModel } from 'src/app/core/models/sugerencias.model';
import { SugerenciaService } from 'src/app/core/services/sugerencia.service';
import { take } from 'rxjs/operators';
import { BaseComponent } from '../../area-privada/components/base/base.component';

@Component({
  selector: 'dum-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss'],
})
export class ContactoComponent extends BaseComponent implements OnInit {

  @ViewChild('sugerenciaForm') form: NgForm;
  email: string;
  sugerencia: SugerenciasModel = new SugerenciasModel();
  mensajeErrorEmail: boolean = false;

  constructor(
     private sugerenciaService: SugerenciaService,
     private translateService: TranslateService,
  ) {
    super();
  }

  ngOnInit(): void { }

  validateEmail() {
    const re = /^(([^<>()[\]{}'^?\\.,!|//#%*-+=&;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (re.test(this.email)) {
      this.mensajeErrorEmail = false;
      return true;
    }
    else {
      this.mensajeErrorEmail = true;
      return false;
    }
  }

  enviar() {
    this.sugerenciaService.save(this.sugerencia)
      .pipe(take(1))
      .subscribe((sugerencia) => {
        this.sugerencia = sugerencia;
        this.dumToast.add({ severity: 'success', summary: this.translateService.instant('RECLAMACIONES.RECLAMACIONES'), detail: `${this.translateService.instant('RECLAMACIONES.EXITO.MSG')}` });
      },
      (error) => {
        this.dumToast.add({severity: 'error', summary: this.translateService.instant('GLOBAL.ERROR'), detail: `${error.error.MSG}`});
      });
  }

}
